import React from 'react';
import * as Sentry from "@sentry/react";
import './App.css';
import { Route } from 'react-router-dom';
import Navbar from './containers/Navbar';
import Drawer from './containers/Drawer';
import Solicitudes from './containers/Solicitudes';
import Dashboard from './containers/Dashboard';
import GestionProveedores from './containers/GestionProveedores';
import Proyectos from './containers/Proyectos';
import Clases from './containers/Clases';
import SubClases from './containers/SubClases';
import AccionDirecta from './containers/AccionDirecta';
import NuevaSolicitud from './containers/NuevaSolicitud';
import DetalleSolicitudes from './containers/DetalleSolicitudes';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { esES } from '@material-ui/core/locale';
import { auth } from './services/firebase';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as solicitudesDuck from './ducks/Solicitudes';
import * as solicitudesUsuarioDuck from './ducks/SolicitudesUsuario';
import * as solicitudesAprobarDuck from './ducks/SolicitudesAprobar';
import * as gerenciaDuck from './ducks/Gerencias';
import * as proyectoDuck from './ducks/Proyectos';
import * as usuarioDuck from './ducks/Usuario';
import * as permisosDuck from './ducks/PermisosUsuario';
import * as estadoDucks from './ducks/Estados';
import * as clasesDuck from './ducks/Clases';
import * as subClaseDuck from './ducks/Subclases';
import * as usuariosDuck from './ducks/Usuarios';
import * as centrosDuck from './ducks/Centros';
import * as empresasDuck from './ducks/Empresas';
import * as proveedoresDuck from './ducks/Proveedores';
import * as mensajesDuck from './ducks/Mensajes';
import * as perfilesDuck from './ducks/Perfiles';
import * as proyectosGeneralDuck from './ducks/ProyectosGeneral';
import * as gerenciasGeneralDuck from './ducks/GerenciasGeneral';
import * as centroLogisticoDuck from './ducks/CentroLogistico';
import * as marcasVehiculosDuck from './ducks/MarcasVehiculos';
import * as rangosPreciosDuck from './ducks/RangosPrecios';
import * as aprobadoresCotizacionDuck from './ducks/AprobadoresCotizacion';
import * as tiposRercursosDuck from './ducks/TiposRecursos';
import * as equipamientosDuck from './ducks/Equipamientos';
import * as coloresDuck from './ducks/Colores';
import * as ramDuck from './ducks/MemoriaRam';
import * as discosDurosDuck from './ducks/DiscosDuros';
import * as procesadoresDuck from './ducks/Procesadores';
import * as tipoMotorDuck from './ducks/TipoMotor';
import * as cilindradaDuck from './ducks/Cilindrada';
import * as traccionDuck from './ducks/Traccion';
import * as comunasDuck from './ducks/Comunas';
import { cerrarSesion } from './services/auth.js';
import Modal from './components/Modal';
import LoadingPage from './components/LoadingPage';
import { obtenerInfoUsuario } from './services/api';
import { ACCOUNT, API_USUARIOS } from './utils/urls.js';

const theme = createMuiTheme(
	{
		spacing: 2,
		palette: {
			primary: {
				light: '#a64c46',
				main: '#731f1f',
				dark: '#430000',
				contrastText: '#fff'
			},
			secondary: {
				light: '#4f5b62',
				main: '#263238',
				dark: '#000a12',
				contrastText: '#fff'
			},
			blanco: {
				light: '#fff',
				main: '#fff',
				dark: '#fff',
				contrastText: '#fff'
			}
		},
		typography: {
			fontSize: 12
		}
	},
	esES
);

class App extends React.Component {
	state = {
		loading: true,
		modal: false,
		confirmacion: false,
		usuario: {},
		accion: null,
		gerenciasUsuario: null
	};

	getQueryVariable(variable) {
		const query = window.location.search.substring(1);
		const vars = query.split('&');
		for (let i = 0; i < vars.length; i++) {
			let pair = vars[i].split('=');
			if (pair[0] === variable) {
				return pair[1];
			}
		}
		return false;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	login = () => {
		var csrfToken = '';
		if (this.getQueryVariable('csrfToken')) {
			csrfToken = this.getQueryVariable('csrfToken');
		} else if (localStorage.getItem('csrfToken')) {
			csrfToken = localStorage.getItem('csrfToken');
		}
		localStorage.setItem('csrfToken', csrfToken);

		const verifyURL = `${API_USUARIOS}/login/verifySessionCookie?_csrf=${csrfToken}`;
		// Realizar la solicitud para verificar la cookie de sesión
		fetch(verifyURL, {
			method: 'post',
			credentials: 'include'
		})
			.then(response => response.json())
			.then(jsonResponse => {
				auth.signInWithCustomToken(jsonResponse.token);
			})
			.catch(error => {
				console.error(error);
				const origin = `${ACCOUNT}/?origin=${window.location.href.split('?')[0]}`;
				window.location.href = origin;
			});
	};

	handleClose = () => {
		this.setState({ ...this.state, confirmacion: false, modal: false, accion: false });
	};

	handleConfirmacion = e => {
		const { assignMensaje } = this.props;
		assignMensaje('¿Está seguro que desea cerrar sesión?');
		this.setState({ ...this.state, modal: true, confirmacion: true, accion: this.handleCerrarSesion() });
	};

	handlePerfil = e => {
		const { assignMensaje, perfiles } = this.props;
		const perfilesMap = perfiles.data.map(x => x.descripcion);
		assignMensaje(`Su perfil actual es: ${perfilesMap.join(", ")}.`);
		this.setState({ ...this.state, modal: true, confirmacion: false, accion: false });
	};

	handleCerrarSesion = () => async e => {
		try {
			await cerrarSesion();
		} catch (error) {
			console.log(error);
		}
	};

	componentDidMount() {
		const {
			agregarUsuario,
			agregarPerfiles,
			agregarPermisos,
		} = this.props;
		this._isMounted = true;
		const usuario = async () => {
			auth.onAuthStateChanged(async user => {
				try {
					if (user) {
						const usuario = await obtenerInfoUsuario(user.uid);
						const datosSentry = {
							id: usuario._id,
							username: `${usuario.nombre} ${usuario.apellidos}`,
							email: user.email,
						}
						Sentry.setUser(datosSentry);
						const datosUsuario = {
							...user,
							id: usuario._id,
							nombres: `${usuario.nombre} ${usuario.apellidos}`,
						}
						await Promise.all([
							agregarUsuario(datosUsuario),
							agregarPerfiles(usuario.perfiles || []),
							agregarPermisos(usuario.permisos || []),
						]);
						if (this._isMounted === true) {
							this.setState({ ...this.state, usuario: user, loading: false });
						}
					} else {
						this.login();
					}
				} catch (error) {
					console.error(error);
				}
			});
		};
		usuario();
	}

	render() {
		const { usuarioAutenticado, history, mensaje } = this.props;
		const { usuario } = this.state;
		return (
			<ThemeProvider theme={theme}>
				{this.state.loading ? (
					<LoadingPage />
				) : (
					<div>
						<Route path="/" component={Navbar} />
						<Route path="/" component={Drawer} />
						<div style={{ padding: '5rem 1rem' }}>
							<Route
								exact={true}
								path="/"
								render={() => <Solicitudes usuario={usuario} history={history} />}
							/>
							<Route
								exact={true}
								path="/nuevasolicitud"
								render={() => (
									<NuevaSolicitud history={history} usuarioAutenticado={usuarioAutenticado.data} />
								)}
							/>
							<Route
								exact={true}
								path="/dashboard"
								component={Dashboard}
							/>
							<Route
								exact={true}
								path="/detalle/:id"
								component={DetalleSolicitudes}
							/>
							<Route
								exact={true}
								path="/configuracion/proyectos"
								component={Proyectos}
							/>
							<Route
								exact={true}
								path="/configuracion/proveedores"
								component={GestionProveedores}
							/>
							<Route
								exact={true}
								path="/configuracion/clases"
								component={Clases}
							/>
							<Route
								exact={true}
								path="/configuracion/subclases"
								component={SubClases}
							/>
							<Route
								exact={true}
								path="/accion"
								render={() => <AccionDirecta history={history} />}
							/>
						</div>
					</div>
				)}
				<Modal
					open={this.state.modal}
					handleClose={this.handleClose}
					confirmacion={this.state.confirmacion}
					accion={this.state.accion}
					loading={false}>
					{mensaje.data}
				</Modal>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = state => {
	return {
		usuarioAutenticado: state.Usuario,
		gerencias: state.Gerencias.data,
		gerenciasTodas: state.GerenciasGeneral.data,
		proyectos: state.Proyectos.data,
		mensaje: state.Mensajes,
		perfiles: state.Perfiles,
		permisos: state.PermisosUsuario
	};
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...solicitudesDuck,
			...solicitudesUsuarioDuck,
			...solicitudesAprobarDuck,
			...gerenciaDuck,
			...proyectoDuck,
			...usuarioDuck,
			...permisosDuck,
			...estadoDucks,
			...clasesDuck,
			...subClaseDuck,
			...usuariosDuck,
			...empresasDuck,
			...centrosDuck,
			...proveedoresDuck,
			...mensajesDuck,
			...perfilesDuck,
			...proyectosGeneralDuck,
			...gerenciasGeneralDuck,
			...centroLogisticoDuck,
			...rangosPreciosDuck,
			...aprobadoresCotizacionDuck,
			...marcasVehiculosDuck,
			...tiposRercursosDuck,
			...equipamientosDuck,
			...coloresDuck,
			...procesadoresDuck,
			...discosDurosDuck,
			...cilindradaDuck,
			...tipoMotorDuck,
			...traccionDuck,
			...ramDuck,
			...comunasDuck
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(App);